import { getWebInstrumentations } from '@grafana/faro-web-sdk';

const faroConfig = {
    url: 'https://faro-collector-prod-us-east-0.grafana.net/collect/9a64f6e884daeff521ad88048cc79a96',
    app: {
        name: 'deal-web',
        version: '1.0.0',
        environment: process.env.NODE_ENV,
    },
    isolate: true,
    instrumentations: [...getWebInstrumentations()],
};

export default faroConfig;
